import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type RecentItem = {
    label: string
    type: 'chart' | 'drawing'
    icon?: string
}
interface QuickSearchState {
    recentChart: RecentItem[];  
    recentSymbol: RecentItem[]; 
}

const initialState: QuickSearchState = {
    recentChart: [],
    recentSymbol: [],
}

const quickSearchSlice = createSlice({
    name: 'quickSearch',
    initialState,
    reducers: {
        addRecentItem: (state, action: PayloadAction<{ context: 'chart' | 'symbol'; item: RecentItem }>) => {
            const { context, item } = action.payload;

            if (context === 'chart') {
                state.recentChart = state.recentChart || []; 
                state.recentChart = state.recentChart.filter((i) => i.label !== item.label);
                state.recentChart.unshift(item);
                if (state.recentChart.length > 10) state.recentChart.pop();
            } else {
                state.recentSymbol = state.recentSymbol || []; 
                state.recentSymbol = state.recentSymbol.filter((i) => i.label !== item.label);
                state.recentSymbol.unshift(item);
                if (state.recentSymbol.length > 10) state.recentSymbol.pop();
            }
        },
    },
})

export const { addRecentItem } = quickSearchSlice.actions
export default quickSearchSlice.reducer
